module.exports = __webpack_public_path__ + "img/head.d4e7708f.png";